var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { maxBy, minBy } from "lodash-es";
import Component from 'vue-class-component';
import Vue from 'vue';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { isInsideRect, number2Px } from "../../../lib/utils/styling";
import { Inject } from 'vue-property-decorator';
import { deepCompPathCapture } from "../../../lib/designer/utils/compCapture";
import styles from "./styles.module.css";
import { getInspectLineStyle, getIntersectionRect, getLineLength, isIntersect, lineCrossRect, rectMiddleX, rectMiddleY, round } from "../../../lib/comps/CompInspector/utils";
import { domDfs } from "../../../lib/utils/browser/domBfs";
let CompInspector = class CompInspector extends Vue {
  constructor() {
    super(...arguments);
    this.compPath = '';
    this.hoveringCompPath = '';
    this.useHoverEl = false;
    this.elTemp = null;
  }
  onMouseMove(ev) {
    var _ev$event;
    if (!ev.clientX && !ev.clientY) return;
    const {
      designer
    } = this;
    const {
      clientX,
      clientY
    } = ev;
    // @ts-ignore
    const shiftKey = (ev === null || ev === void 0 || (_ev$event = ev.event) === null || _ev$event === void 0 ? void 0 : _ev$event.shiftKey) || (ev === null || ev === void 0 ? void 0 : ev.shiftKey);
    this.compPath = designer.compPath;
    // hoverElement下钻+选中组件
    if (shiftKey) {
      const editZoneCanvas = designer.$refs.editZone.$refs.rendererCanvas;
      const jumpDfs = el => !isInsideRect(clientX, clientY, el.getBoundingClientRect());
      const it = domDfs(editZoneCanvas, jumpDfs, true);
      const el = it.next().value;
      if (el) {
        this.useHoverEl = true;
        this.elTemp = el;
        return;
      }
    }
    this.useHoverEl = false;
    this.elTemp = null;
    {
      const mouseCompPath = designer.compFromPoint(ev.clientX, ev.clientY, () => true);
      // @ts-ignore
      const hoverCompPath = deepCompPathCapture(mouseCompPath, ev, designer);
      designer.hoveringCompPath = hoverCompPath;
      this.hoveringCompPath = designer.hoveringCompPath;
    }
  }
  pxByZoom(num) {
    return num / this.designer.getZoomPercentage();
  }
  get mainElement() {
    return this.designer.renderer.getRefByPath(this.compPath).$el;
  }
  get hoverElement() {
    if (this.useHoverEl) {
      return this.elTemp;
    }
    return this.designer.renderer.getRefByPath(this.hoveringCompPath).$el;
  }
  get mainRect() {
    return this.mainElement.getBoundingClientRect();
  }
  get hoverRect() {
    return this.hoverElement.getBoundingClientRect();
  }
  get hoverSelf() {
    return this.mainElement === this.hoverElement;
  }
  renderRectSize(rect, mini = false) {
    const h = this.$createElement;
    const containerStyle = number2Px({
      top: rect.bottom,
      left: rectMiddleX(rect)
    });
    return h("div", {
      "style": containerStyle
    }, [h("div", {
      "class": [styles.bottom, mini && styles.mini]
    }, [round(this.pxByZoom(rect.width)), "\xD7", round(this.pxByZoom(rect.height))])]);
  }
  get renderBottomSize() {
    const {
      mainRect
    } = this;
    return this.renderRectSize(mainRect);
  }
  get intersectionRect() {
    const {
      hoverRect,
      mainRect
    } = this;
    return getIntersectionRect(hoverRect, mainRect);
  }
  /** 两个rect相交时 从相交区域出发 向上下左右连四条线 */
  get renderRectIntersect() {
    const h = this.$createElement;
    const {
      hoverRect,
      mainRect
    } = this;
    const rectIntersect = this.intersectionRect;
    if (!rectIntersect) return null;
    const top = Math.min(mainRect.top, hoverRect.top);
    const left = Math.min(mainRect.left, hoverRect.left);
    const right = Math.max(mainRect.right, hoverRect.right);
    const bottom = Math.max(mainRect.bottom, hoverRect.bottom);
    const xMiddle = rectIntersect.left + rectIntersect.width / 2;
    const yMiddle = rectIntersect.top + rectIntersect.height / 2;
    return h("div", [this.renderLine([left, rectIntersect.left], 'h', yMiddle), this.renderLine([right, rectIntersect.right], 'h', yMiddle), this.renderLine([top, rectIntersect.top], 'v', xMiddle), this.renderLine([bottom, rectIntersect.bottom], 'v', xMiddle), this.renderHoverBorder(rectIntersect)]);
  }
  renderLineLength(length) {
    const h = this.$createElement;
    return h("div", [h("div", {
      "class": styles.length
    }, [round(this.pxByZoom(length))])]);
  }
  /** 横向/纵向 从boundary的区间内 连一条线段 并标注线段的长度 */
  renderLine(boundary, direction, pos, showLength = true) {
    const h = this.$createElement;
    const lineLength = getLineLength(...boundary);
    if (lineLength === 0) return null;
    const lineStyle = getInspectLineStyle(boundary[0], boundary[1], direction, pos, {
      borderStyle: showLength ? 'solid' : 'dashed'
    });
    return h("div", {
      "class": [styles.line, styles[direction], !showLength && styles.dashed],
      "style": lineStyle
    }, [showLength && this.renderLineLength(lineLength)]);
  }
  /** 两个矩形有上下关系时 连线表示纵向距离 */
  get renderYIntersect() {
    const h = this.$createElement;
    // 从mainRect中点竖着连线到目标
    const {
      hoverRect,
      mainRect
    } = this;
    const yIntersect = isIntersect(mainRect.top, mainRect.bottom, hoverRect.top, hoverRect.bottom);
    const vNodes = [];
    if (!yIntersect) {
      const lineBoundary = mainRect.bottom < hoverRect.top ? [hoverRect.top, mainRect.bottom] : [hoverRect.bottom, mainRect.top];
      const pos = rectMiddleX(mainRect);
      vNodes.push(this.renderLine(lineBoundary, 'v', pos));
      if (!lineCrossRect(pos, 'v', hoverRect)) {
        // 如果没直接连到目标 要来条虚线
        const boundaryB = hoverRect.right < mainRect.left ? hoverRect.right : hoverRect.left;
        const top = lineBoundary[0];
        vNodes.push(this.renderLine([pos, boundaryB], 'h', top, false));
      }
    } else {
      if (mainRect.top === hoverRect.top) {
        return this.renderLine([rectMiddleX(mainRect), rectMiddleX(hoverRect)], 'h', mainRect.top, false);
      }
      // 找最靠顶部的那个
      const leftRect = minBy([mainRect, hoverRect], 'top');
      const rightRect = maxBy([mainRect, hoverRect], 'top');
      // 向另一个目标的方向连线 首先横向连到另一个目标的中点
      const boundaryA = leftRect.left > rightRect.right ? leftRect.left : leftRect.right;
      const boundaryB = rectMiddleX(rightRect);
      vNodes.push(this.renderLine([boundaryA, boundaryB], 'h', leftRect.top, false));
      // 纵向连过去显示间距
      vNodes.push(this.renderLine([leftRect.top, rightRect.top], 'v', boundaryB));
    }
    return h("div", [vNodes]);
  }
  /** 两个矩形有左右关系时 连线表示横向距离 */
  get renderXInstersect() {
    const h = this.$createElement;
    const {
      hoverRect,
      mainRect
    } = this;
    const xIntersect = isIntersect(mainRect.left, mainRect.right, hoverRect.left, hoverRect.right);
    const vNodes = [];
    if (!xIntersect) {
      const lineBoundary = mainRect.right < hoverRect.left ? [hoverRect.left, mainRect.right] : [hoverRect.right, mainRect.left];
      const pos = rectMiddleY(mainRect);
      vNodes.push(this.renderLine(lineBoundary, 'h', pos));
      if (!lineCrossRect(pos, 'h', hoverRect)) {
        // 如果没直接连到目标 要来条虚线
        const boundaryB = hoverRect.bottom < mainRect.top ? hoverRect.bottom : hoverRect.top;
        const top = lineBoundary[0];
        vNodes.push(this.renderLine([pos, boundaryB], 'v', top, false));
      }
    } else {
      if (mainRect.left === hoverRect.left) {
        return this.renderLine([rectMiddleY(mainRect), rectMiddleY(hoverRect)], 'v', mainRect.left, false);
      }
      // 找最靠左的那个
      const leftRect = minBy([mainRect, hoverRect], 'left');
      const rightRect = maxBy([mainRect, hoverRect], 'left');
      // 向另一个目标的方向连线 首先纵向连到另一个目标的中点
      const boundaryA = leftRect.top > rightRect.bottom ? leftRect.top : leftRect.bottom;
      const boundaryB = rectMiddleY(rightRect);
      vNodes.push(this.renderLine([boundaryA, boundaryB], 'v', leftRect.left, false));
      // 横线连过去显示间距
      vNodes.push(this.renderLine([leftRect.left, rightRect.left], 'h', boundaryB));
    }
    return h("div", [vNodes]);
  }
  renderHoverBorder(rect) {
    const h = this.$createElement;
    return h("div", [this.renderLine([rect.left, rect.right], 'h', rect.top, false), this.renderLine([rect.left, rect.right], 'h', rect.bottom, false), this.renderLine([rect.top, rect.bottom], 'v', rect.left, false), this.renderLine([rect.top, rect.bottom], 'v', rect.right, false)]);
  }
  /** 元素渲染在canvasWrapper里 但是使用boundingRect定位坐标 所以要加上canvasWrapper本身的偏移 */
  getCanvasOffsetStyle() {
    const canvas = this.designer.$el.querySelector('.ucd-editZone-canvas');
    const designerRect = canvas.getBoundingClientRect();
    const designerTranslate = {
      transform: `translate(${-1 * designerRect.left}px,${-1 * designerRect.top}px)`
    };
    return designerTranslate;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": styles.inspector,
      "style": this.getCanvasOffsetStyle()
    }, [this.renderBottomSize, this.useHoverEl && this.renderRectSize(this.hoverRect, true), !this.hoverSelf && (this.intersectionRect ? this.renderRectIntersect : [this.renderYIntersect, this.renderXInstersect, this.useHoverEl && this.renderHoverBorder(this.hoverRect)])]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], CompInspector.prototype, "designer", void 0);
CompInspector = __decorate([Component({
  name: 'CompInspector',
  props: {}
})], CompInspector);
export { CompInspector };
//# sourceMappingURL=index.js.map
